import { Link } from "react-router-dom";
import type { Work } from "@/types";

const typeLabel: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  web: "网络剧",
};

interface WorkCardProps {
  work: Work;
  index?: number;
}

export default function WorkCard({ work, index = 0 }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title}影视封面`}
          title={`${work.title}剧情介绍与角色分析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/80 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {typeLabel[work.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px]"></i>
          </span>
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/85 to-transparent"></div>
        <p className="absolute inset-x-0 bottom-0 px-3 pb-2 text-[11px] leading-snug text-primary-100 line-clamp-2 opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
          {work.tagline}
        </p>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1">
          {work.title}
        </h3>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="text-background-400">·</span>
          <span>{work.region}</span>
        </div>
        <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 line-clamp-2">
          {work.synopsis}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}